var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("Headline", { attrs: { level: 2, styling: "page-title" } }, [
        _vm._v("Wilkommen bei der Garde"),
      ]),
      _c("Separator"),
      _c("TopicHeader", {
        attrs: { src: _vm.karneval, title: "Der Karneval" },
      }),
      _c("Paragraph", [
        _vm._v(
          " Mit mehr als 80 Uniformierten stellt die Ehrengarde in der Deichstadt die größte Garde. Besonders stolz ist die Garde auf ihre Vielzahl eigener Gewächse. Hierzu zählt natürlich die Aktive Garde mit ihrem alljährlichen Gardetanz, die Showtanzgruppe „Traumtänzerkompanie“, das Piccolokorps, mehrere Büttenredner aus den eigenen Reihen und Bühnenstücke der Reservisten der Garde. So ist es kaum verwunderlich, dass die Ehrengarde das eigene Sitzungsprogramm fast ausschließlich aus den eigenen Reihen bestreiten kann. Wenn die eigene Sitzung dann erfolgreich gemeistert wurde, steht für die Garde der reine Spaß im Vordergrund. Diesen Spaß versucht sie von der Bühne ins Publikum zu übertragen. Dabei ist die Garde gern gesehener Bühnengast bei unzähligen Veranstaltungen in und um Neuwied, aber auch weit über die Stadtgrenzen hinaus. Spätestens, wenn es dann an den Straßenkarneval geht, ist die Ehrengarde kaum zu übersehen. "
        ),
      ]),
      _c("Separator"),
      _c("TopicHeader", {
        attrs: { src: _vm.historisch, title: "Die Historie" },
      }),
      _c("Paragraph", [
        _vm._v(
          " Anlässlich der 300-Jahr-Feier der Stadt Neuwied wurde eine Gruppe junger Männer mit originalgetreuen Uniformen der wiedischen Grenadiere eingekleidet. Diese Gruppe stellt im Festumzug zum Stadtjubiläum 1953 einen historisch bedeutsamen Teil der Stadtgeschichte dar. Dies war die Geburtsstunde der Ehrengarde der Stadt Neuwied. Ihrer historischen Rolle werden die Grenadiere der Garde in ihren originalgetreuen Uniformen als Repräsentant der Stadt Neuwied noch heute gerecht. Bei Anlässen wie Rheinland-Pfalz-Tagen, Empfängen und historischen Festen oder Städtepartnerschaften verstehen sie sich als ein Stück Stadtgeschichte zum Anfassen. Bei historischen Anlässen tragen die Damen des Vereins handgemachte Gewandungen, die dem weiblichen, einfachen Volk um 1750 entspricht. "
        ),
      ]),
      _c("Separator"),
      _c("SocialMedia"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }